import {css} from '@mui/material';
import styled from 'styled-components';
import {StyledLineProps} from './types';

const StyledLine = styled.p<StyledLineProps>`
	font-size: 0.875rem;
	line-height: 1.531rem;
	margin-bottom: ${({$noMargin}) => ($noMargin ? 0 : '1.531rem')};
	${({$bold}) =>
		$bold
			? css`
					font-weight: 700;
				`
			: null}
`;

const StyledListItem = styled.li`
	font-size: 0.875rem;
	line-height: 1.531rem;
`;

const StyledUnOrderList = styled.ul<StyledLineProps>`
	list-style: disc;
	padding: 0 18px;
	margin-bottom: ${({$noMargin}) => ($noMargin ? 0 : '1.531rem')};
`;

const StyledOrderList = styled.ol`
	padding: 0 24px;
	margin-bottom: 1.531rem;
`;

export {StyledLine, StyledUnOrderList, StyledOrderList, StyledListItem};
